import { Col, Row } from 'react-bootstrap'
import styles from './Calendar.module.css'

export default function Calendar() {
    const calendar = "./assets/images/calendar.png"
    const calendarMobile = "./assets/images/calendar-mobile.png"
    
    return (
        <section>
            <Row className={`${ styles.container } m-auto align-items-center justify-content-center mt-5`}>
                <Col xs="12" sm="12" md="12" lg="12" className='p-0'>
                    <img src={calendar} alt='calendar' className={ `${styles.calendar} d-none d-md-block mt-5`}/>
                    <img src={calendarMobile} alt='calendarMobile' className={ `${styles.calendar} d-sm-block d-md-none mt-5`}/>
                </Col>
            </Row>
        </section>
    )
}